import { jsx, css } from '@emotion/react';
import React, { useState, useEffect } from 'react';

// Components

import ContentHeader from './Residential/ContentHeader';
import Map from './Residential/Map';
import FilterListResults from '../ComponentLibrary/filter-list/oc-filter-list-results';
import { ProfessionalResultBlock } from '../ComponentLibrary/filter-result-blocks/oc-professional-result-block';
import UtilityBar from '../ComponentLibrary/layout/oc-utility-bar';
import { Breadcrumbs, Breadcrumb } from '../ComponentLibrary/oc-breadcrumbs';
import DistanceSelector from '../ComponentLibrary/oc-distance-selector';
import Container from '../OC/oc-container';
import Hero from '../OC/oc-hero';
import { connectLocation } from '../location/LocationConnectors';
import LocationSwitcher from '../location/Switcher';
import wrappedInReduxProvider from '../wrappedInReduxProvider';

const ResultComponent = ({ ...props }) => <ProfessionalResultBlock resource={props} />;

const AirDistributors = ({ ...props }) => {
  const contentHeaderProps = { valid: props.address.valid, city: props.address.city, region: props.address.region };

  const parseData = result =>
    result.data.map(row => ({
      address: row.address,
      city: row.city,
      country: row.country,
      distance: row.distance,
      latitude: row.latitude,
      longitude: row.longitude,
      phone: row.phone,
      record_id: row.locatable_id,
      state: row.state,
      name: row.name,
      type: row.locatable_type,
      zip: row.postal,
      website_address: row.website,
    }));

  const [lists, setLists] = useState([{ name: 'dealers', data: parseData(props.result) }]);

  const getObjQuery = (name, obj) => {
    let query = ``;
    Object.keys(obj).forEach(key => (query += `${name}[${key}]=${encodeURIComponent(obj[key])}&`));
    return query;
  };

  const updateDistance = radius => {
    if (props.address.valid) {
      fetch(
        `${MDMS_URL}/api/v2/locations/insulation/find-hvac-contractor?radius=${radius}&${getObjQuery(
          'address',
          props.address
        )}`
      )
        .then(
          response => response.json(),
          err => {}
        )
        .then(json => setLists([{ name: 'dealers', data: parseData(json) }]));
    }
  };

  const filters = {
    distance: {
      component: DistanceSelector,
      displayName: 'Distance',
      options: [
        { displayName: '20', value: '20' },
        { displayName: '40', value: '40' },
        { displayName: '60', value: '60' },
      ],
      matchType: 'ajax',
      onChange: updateDistance,
    },
  };

  return (
    <>
      <UtilityBar>
        <Breadcrumbs>
          <Breadcrumb href="/insulation" label="Insulation" />
        </Breadcrumbs>
        <LocationSwitcher />
      </UtilityBar>

      <div
        css={css`
          & > div {
            @media (max-width: 1199px) {
              background-size: cover;
            }
          }
        `}
      >
        <Hero
          imgDesktop={{
            file:
              'https://imagecdn.owenscorning.com/ocimages/image/upload/q_auto/v1669121051/insulation/hvac-contractor-locator/hero-desktop.png',
          }}
          imgTablet={{
            file:
              'https://imagecdn.owenscorning.com/ocimages/image/upload/q_auto/v1669121051/insulation/hvac-contractor-locator/hero-desktop.png',
          }}
          prehead=""
          h1="AirCare™ HVAC Locator"
          posthead="AirCare™ Professional Contractors"
        />
      </div>

      <Container maxWidth="1170">
        <FilterListResults
          contentHeader={{ component: ContentHeader, props: contentHeaderProps }}
          defaultDistance={20}
          filters={filters}
          lists={lists}
          primaryActiveDefault
          resetDistance={updateDistance}
          resultComponent={ResultComponent}
          secondaryContent={Map}
        />
      </Container>
    </>
  );
};

export default wrappedInReduxProvider(connectLocation(AirDistributors));
